
export class TimeUtil {
  /**
   * Date 型に変換します.
   * null の場合、null を返却します.
   *
   * @param value 値
   * @returns Date 型
   */
  public static toDate(value: number): Date {
    if (value) {
      return new Date(value);
    }

    return null;
  }

  /**
   * 日付が同じか判定します.
   * どちらかが null の場合、false を返却します.
   *
   * @param date1 日時１
   * @param date2 日時２
   * @returns 結果
   */
  public static isDate(date1: Date, date2: Date): boolean {
    if (date1 && date2) {
      return date1.getFullYear() === date2.getFullYear()
        && date1.getMonth() === date2.getMonth()
        && date1.getDate() === date2.getDate();
    } else if (date1) {
      return false;
    } else if (date2) {
      return false;
    }

    return true;
  }

  /**
   * 現在日時と指定日時との差を分で返却します.
   *
   * @param date 日時
   * @returns 分
   */
  public static getDiffMinutes(date: Date): number {
    const current = new Date();
    const timeDiff = date.getTime() - current.getTime();

    return Math.floor(timeDiff / (60 * 1000));
  }
}



// WEBPACK FOOTER //
// ./src/utilities/time-util.ts